import AppShell from "./AppShell";
import { getApp } from "@/lib/apps";

const Ablelynq = () => <AppShell app={getApp("ablelynq")} />;

export default Ablelynq;
